<template>
  <div class="share">
    <a class="share__item" href=""><img width="30" height="30" src="/static/img/icons/line.svg"></a>
    <a class="share__item" href=""><img width="30" height="30" src="/static/img/icons/twitter.svg"></a>
    <a class="share__item" href=""><img width="30" height="30" src="/static/img/icons/facebook.svg"></a>
  </div>
</template>

<script>
export default {
  name: 'share-buttons'
}</script>

<style>

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ShareButtons.vue